import validate from "/home/unwar190/web/underwar.org/public_html/node_modules/nuxt/dist/pages/runtime/validate.js";
import scroll_45top_45global from "/home/unwar190/web/underwar.org/public_html/middleware/scroll-top.global.ts";
import manifest_45route_45rule from "/home/unwar190/web/underwar.org/public_html/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  scroll_45top_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-logged-in": () => import("/home/unwar190/web/underwar.org/public_html/middleware/isLoggedIn.js"),
  "is-logged-out": () => import("/home/unwar190/web/underwar.org/public_html/middleware/isLoggedOut.js")
}